import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastsComponent } from '@kros-sk/ui/toast';

@Component({
  selector: 'kros-root',
  imports: [RouterOutlet, ToastsComponent],
  template: `
    <router-outlet />

    <kros-toasts
      aria-live="polite"
      aria-atomic="true"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
